<template>
    <div>
        <h2 class="u-margin-top-30 u-margin-bottom-30">
            Losses for Care
        </h2>
    
        <div class="flex-grid flex-grid--reduced-bottom-margin a-form-inputs" >
            <div class="flex-grid__item">
                <control for="future_loss_of_care" label="Would you like to make a claim for care?">
                    <select id="future_loss_of_care"
                            v-model="futureLossOfCare"
                            v-field-control
                            required>
                        <option :value="null" disabled hidden>Please select...</option>
                        <option :value="true">Yes</option>
                        <option :value="false">No</option>
                    </select>
                </control>
            </div>
        </div>

        <div v-if="futureLossOfCare">
            <div v-for="(period, periodIndex) in care">
                <futureCarePeriod
                        :index="periodIndex"
                        :care="period"
                ></futureCarePeriod>
            </div>
            <button type="button" class="a-button a-button--no-margin" @click="addCare">Add Care Period</button>
        </div>

        <div v-if="futureLossOfCare && futureLossOfCareValid">
            <div class="a-table a-table--short-no-style a-table--full-width u-margin-top-50">
                <table cellspacing="0" cellpadding="0" class="a-table--full-width">
                    <thead>
                    <tr>
                        <th>Date from</th>
                        <th>Date to</th>
                        <th>Multiplicand</th>
                        <th>Duration (years)</th>
                        <th>Multiplier</th>
                        <th>Future Care Loss</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(period) in care">
                        <td>{{ period.careStartDate }}</td>
                        <td>{{ period.careEndDate }}</td>
                        <td>{{ currencyFormat(period.multiplicand) }}</td>
                        <td>{{ roundValue(period.duration, 2) }}</td>
                        <td>{{ roundValue(period.multiplier, 2) }}</td>
                        <td>
                            <tr>
                                <td style="border: none; padding: 0px;">
                                    {{ currencyFormat(period.futureCareTotal) }}
                                </td>
                                <td style="border: none; padding: 0 0 0 10px">
                                    <div @click="toggleModal(period)">
                                        <icon-tooltip
                                                :tooltip-name="'calculation_' + uniqueId"
                                                tooltip-text="Click to view calculation"
                                                side="left"
                                                text-width="140"
                                                icon-type="formula"
                                        ></icon-tooltip>
                                    </div>
                                </td>
                            </tr>
                        </td>
                    </tr>
                    </tbody>
                    <tfoot>
                        <tr class="a-table--grey">
                            <td class="u-text-right u-bold" colspan="5">Total</td>
                            <td><strong>{{ currencyFormat(careTotal) }}</strong></td>
                        </tr>
                    </tfoot>
                </table>
                <br>
            </div>
        </div>

        <modal :name="'calculation_' + uniqueId" no-default-button="true">
            <modal-content></modal-content>
        </modal>

    </div>
</template>
<script>
    import Control from 'components/form/Control.vue';
    import ControlError from 'components/form/control/Error.vue';
    import currencyFormat from 'mixins/currencyFormat';
    import DateInput from 'components/form/control/DateInput.vue';
    import FormValidator from 'components/form/validator/mixin';
    import LifeExpectancy from 'components/LifeExpectancy.vue';
    import roundValue from 'mixins/roundValue';
    import TwoDecimalPlaces from 'directives/TwoDecimalPlaces';
    import {mapActions, mapGetters} from 'vuex';
    import FutureCarePeriod from './FutureCarePeriod.vue';
    import IconTooltip from 'components/IconTooltip';
    import Modal from 'components/modal/Modal.vue';
    import ModalContent from 'components/modal/ModalContent.vue';

    export default {
        name: 'future-care',
        mixins: [
            FormValidator,
            currencyFormat,
            roundValue,
        ],
        components: {
            Control,
            ControlError,
            DateInput,
            LifeExpectancy,
            FutureCarePeriod,
            IconTooltip,
            Modal,
            ModalContent
        },
        directives: {
            'two-dp': TwoDecimalPlaces
        },
        computed: {
            ...mapGetters('personal/otherFutureLosses', [
                'value',
                'care',
                'careTotal',
            ]),
            ...mapGetters('personal/claimant', [
                'claimant',
                'getClaimInfo',
            ]),
            futureLossOfCare: {
                get() {
                    return this.value('futureLossOfCare');
                },
                set(value) {
                    this.set({key: 'futureLossOfCare', value});
                }
            },
            futureLossOfCareValid() {
                return this.care.reduce((valid, care) => valid ? (care.futureCareTotal > 0) : false, true);
            },
            uniqueId() {
                return this._uid;
            }
        },
        methods: {
            ...mapActions('personal/otherFutureLosses', ['set', 'addCare',]),
            ...mapActions('modal', ['toggle', 'getModalContent']),
            toggleModal(period) {
                this.toggle('calculation_' + this.uniqueId);

                this.getModalContent({
                    endpoint: 'futureLossesForCare',
                    payload: {
                        period: period,
                        discountRate: this.getClaimInfo('discountRate'),
                        person: {
                            gender: this.claimant.gender,
                            date_of_birth: this.claimant.dateOfBirth,
                            date_of_assumed_settlement: this.getClaimInfo('dateOfAssumedSettlement'),
                        }
                    }
                });
            },
        },

    }
</script>


// WEBPACK FOOTER //
// FutureCare.vue?205f24b5